import React, {FunctionComponent} from 'react';
import {AppRouter} from 'ui';

interface AppProps {
}

export const App: FunctionComponent<AppProps> = () => {
    return <AppRouter/>;
};
